"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _colors = require("HubStyleTokens/colors");

var _I18n = _interopRequireDefault(require("I18n"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Divider = _interopRequireDefault(require("./Divider"));

var _MoreMenu = _interopRequireDefault(require("./MoreMenu"));

var _Control = _interopRequireDefault(require("./Control"));

var _ToolbarMenu = _interopRequireDefault(require("./ToolbarMenu"));

var _toolbar = require("../../constants/toolbar");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var dividerIndex = 0;

var getDividerIndex = function getDividerIndex() {
  return ++dividerIndex;
};

var ControlGroupDiv = _styledComponents.default.div.withConfig({
  displayName: "ControlGroup__ControlGroupDiv",
  componentId: "mcezxe-0"
})(_templateObject());

var menuStyles = "\n  padding-left: 5px !important;\n  padding-right: 5px !important;\n  font-size: 13px !important;\n  margin-bottom: 1px !important;\n  color: " + _colors.CALYPSO_DARK + " !important;\n";
var StyledMoreMenu = (0, _styledComponents.default)(_MoreMenu.default).withConfig({
  displayName: "ControlGroup__StyledMoreMenu",
  componentId: "mcezxe-1"
})(_templateObject2(), menuStyles);
var StyledToolbarMenu = (0, _styledComponents.default)(_ToolbarMenu.default).withConfig({
  displayName: "ControlGroup__StyledToolbarMenu",
  componentId: "mcezxe-2"
})(_templateObject3(), menuStyles);

var ControlGroup =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ControlGroup, _Component);

  function ControlGroup(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ControlGroup);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ControlGroup).call(this, props));
    _this.renderControl = _this.renderControl.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ControlGroup, [{
    key: "getPrevControlType",
    value: function getPrevControlType(index) {
      var controls = this.props.controls;
      var prevControl = controls[index - 1];
      return prevControl ? prevControl.type : '';
    }
  }, {
    key: "controlRectWithIndex",
    value: function controlRectWithIndex(control) {
      var _this2 = this;

      return function (boundingRect) {
        _this2.props.collectControlRect(control, boundingRect);
      };
    }
  }, {
    key: "renderDivider",
    value: function renderDivider() {
      return _react.default.createElement(_Divider.default, {
        key: "divider-" + getDividerIndex()
      });
    }
  }, {
    key: "renderControlButton",
    value: function renderControlButton(control, index) {
      var _this$props$convertTo = this.props.convertToButton(control),
          renderControl = _this$props$convertTo.renderControl,
          name = _this$props$convertTo.name;

      return _react.default.createElement(_Control.default, {
        controlRect: this.controlRectWithIndex(name),
        prevControlType: this.getPrevControlType(index),
        key: name
      }, renderControl());
    }
  }, {
    key: "renderMoreMenu",
    value: function renderMoreMenu(menuItems, index) {
      return _react.default.createElement(_Control.default, {
        prevControlType: this.getPrevControlType(index),
        key: "more-menu"
      }, _react.default.createElement(StyledMoreMenu, {
        "data-test-id": "more-menu",
        dropdownClassName: this.props.dropdownClassName,
        menuItems: menuItems.map(this.props.convertToButton),
        onOpenComplete: this.props.onMoreMenuOpenComplete,
        toolbarWidth: this.props.toolbarWidth
      }));
    }
  }, {
    key: "renderInsertMenu",
    value: function renderInsertMenu(menuItems, index) {
      return _react.default.createElement(_Control.default, {
        prevControlType: this.getPrevControlType(index),
        key: "insert-menu"
      }, _react.default.createElement(StyledToolbarMenu, {
        "data-test-id": "insert-menu",
        dropdownClassName: this.props.dropdownClassName,
        menuItems: menuItems.map(this.props.convertToMenuItem),
        buttonText: _I18n.default.text(_toolbar.TOOLBAR_I18N_PREFIX + ".insertMenu")
      }));
    }
  }, {
    key: "renderAdvancedMenu",
    value: function renderAdvancedMenu(menuItems, index) {
      return _react.default.createElement(_Control.default, {
        prevControlType: this.getPrevControlType(index),
        key: "advanced-menu"
      }, _react.default.createElement(StyledToolbarMenu, {
        dropdownClassName: this.props.dropdownClassName,
        id: "advanced-menu",
        menuItems: menuItems.map(this.props.convertToMenuItem),
        buttonText: _I18n.default.text(_toolbar.TOOLBAR_I18N_PREFIX + ".advancedMenu")
      }));
    }
  }, {
    key: "renderControl",
    value: function renderControl(_ref, index) {
      var control = _ref.control,
          type = _ref.type,
          menuItems = _ref.menuItems;

      switch (type) {
        case _toolbar.ToolbarControlTypes.DIVIDER:
          return this.renderDivider();

        case _toolbar.ToolbarControlTypes.BUTTON:
        case _toolbar.ToolbarControlTypes.SELECT:
          return this.renderControlButton(control, index);

        case _toolbar.ToolbarControlTypes.MORE_MENU:
          return this.renderMoreMenu(menuItems, index);

        case _toolbar.ToolbarControlTypes.INSERT_MENU:
          return this.renderInsertMenu(menuItems, index);

        case _toolbar.ToolbarControlTypes.ADVANCED_MENU:
          return this.renderAdvancedMenu(menuItems, index);

        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var controls = this.props.controls;
      return _react.default.createElement(ControlGroupDiv, null, controls.map(this.renderControl));
    }
  }]);
  return ControlGroup;
}(_react.Component);

exports.default = ControlGroup;
ControlGroup.propTypes = {
  controls: _react.PropTypes.arrayOf(_toolbar.controlPropType).isRequired,
  convertToButton: _react.PropTypes.func.isRequired,
  convertToMenuItem: _react.PropTypes.func.isRequired,
  toolbarWidth: _react.PropTypes.number.isRequired,
  collectControlRect: _react.PropTypes.func,
  dropdownClassName: _react.PropTypes.string,
  onMoreMenuOpenComplete: _react.PropTypes.func
};
module.exports = exports.default;